import {
    ConsumptionHistory,
    ConsumptionWithDisaggregation,
    HouseCharacterization,
    SmartNowConsumptionEvolution,
    SmartNowConsumptionsValues,
    SmartNowContractOptimization,
    SmartNowEfficiencyEnergetic,
    SmartNowStatus,
    SmartNowStep,
} from "@edp-models/smart-now.model";

export interface ISmartNowState {
    status: SmartNowStatus;
    lastAPIError: Error;
    houseCharacterization: HouseCharacterization;
    step: SmartNowStep;
    previousStepUrl: string;
    flowOrigin: string;
    consumptionWithDesaggregation: ConsumptionWithDisaggregation[];
    prediction: SmartNowConsumptionsValues;
    contractOptimization: SmartNowContractOptimization;
    consumptionPower: any;
    currentPeriodConsumption: ConsumptionWithDisaggregation;
    consumptionEvolution: SmartNowConsumptionEvolution;
    consumptionHistory: ConsumptionHistory;
    efficiencyEnergetic: SmartNowEfficiencyEnergetic;
}

export const initialSmartNowState: ISmartNowState = {
    status: null,
    lastAPIError: null,
    houseCharacterization: null,
    step: null,
    previousStepUrl: null,
    flowOrigin: null,
    consumptionWithDesaggregation: null,
    prediction: null,
    contractOptimization: null,
    consumptionPower: null,
    currentPeriodConsumption: null,
    consumptionEvolution: null,
    consumptionHistory: null,
    efficiencyEnergetic: null,
};
